import { BaseElement, defineElement } from '@webtides/element-js';

class VideoComponent extends BaseElement {
    properties() {
        return {
            videoLink: '',
            editMode: false,
        };
    }

    connected() {
        super.connected();
        const videos = this.querySelectorAll('.video-element');
        const cookieElements = this.querySelectorAll('.cookie-component');

        if (this.videoLink.includes('youtu') && !this.editMode) {
            videos.forEach((video) => video.classList.add('cookieconsent-optin-marketing'));
            cookieElements.forEach((el) => el.classList.add('cookieconsent-optout-marketing'));
        } else if (this.videoLink.includes('youtu') && this.editMode) {
            cookieElements.forEach((el) => {
                el.classList.remove('hidden');
            });
        }
        this.classList.remove('hidden');
    }
}

export function define() {
    defineElement('video-component', VideoComponent);
}
